import React from 'react';
import { Radio, Send } from 'lucide-react';
import Newsletter from '../components/Newsletter';
import { communityMeetingImage, schedule } from '../mock';
import { useToast } from '../hooks/use-toast';

const chat = [
  { id: 'seed-1', user: 'Amara', text: 'Joining from Rotterdam - great to see this online!' },
  { id: 'seed-2', user: 'Wei', text: 'Greetings from Shanghai diaspora group.' },
  { id: 'seed-3', user: 'Kofi', text: 'Powerful conversation today. Thank you DCTV.' },
];

const WatchLive = () => {
  const [msg, setMsg] = React.useState('');
  const [messages, setMessages] = React.useState(chat);
  const { toast } = useToast();

  const send = (e) => {
    e.preventDefault();
    if (!msg.trim()) return;
    const id = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `msg-${Date.now()}`;
    setMessages((prev) => [...prev, { id, user: 'You', text: msg.trim() }]);
    setMsg('');
    toast({ title: 'Message sent', description: 'Your message was added to the live chat.' });
  };

  return (
    <div>
      <section className="pt-[140px] pb-10 px-6 lg:px-10">
        <div className="max-w-[1400px] mx-auto fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#e8743b]/12 border border-[#e8743b]/25">
            <span className="w-2 h-2 rounded-full bg-[#e8743b] pulse-dot" />
            <span className="text-[#e8743b] text-xs font-semibold tracking-wider">LIVE NOW</span>
          </span>
          <h1 className="font-serif-dctv text-5xl md:text-6xl font-bold text-white mt-6">Live stream</h1>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-16">
        <div className="max-w-[1400px] mx-auto grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="relative rounded-2xl overflow-hidden border border-white/8 aspect-video bg-black">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/aqz-KE-bpKQ?rel=0"
                title="DCTV Live"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="mt-5">
              <h2 className="font-serif-dctv text-2xl font-bold text-white">Community Update - Diaspora Voices</h2>
              <p className="text-[#9aa3b2] text-sm leading-relaxed mt-2">
                Live community programming streamed online. Full schedule and channel links are announced through our newsletter and social channels.
              </p>
            </div>
          </div>

          <div className="dctv-card rounded-2xl p-5 flex flex-col h-[520px]">
            <div className="flex items-center gap-2 pb-4 border-b border-white/8">
              <Radio className="w-4 h-4 text-[#e8743b]" />
              <span className="text-white font-semibold text-sm">Live chat</span>
            </div>
            <div className="flex-1 overflow-y-auto py-4 space-y-4">
              {messages.map((m) => (
                <div key={m.id}>
                  <span className="text-[#e8743b] text-xs font-semibold">{m.user}</span>
                  <p className="text-[#cdd2dc] text-sm mt-0.5">{m.text}</p>
                </div>
              ))}
            </div>
            <form onSubmit={send} className="flex items-center gap-2 pt-3 border-t border-white/8">
              <input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Say something..." className="flex-1 px-4 py-2.5 rounded-full bg-[#0a0e16] border border-white/10 text-white text-sm placeholder:text-[#6b7384] focus:outline-none focus:border-[#e8743b]/60" />
              <button type="submit" className="dctv-btn-primary w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                <Send className="w-4 h-4" />
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-16">
        <div className="max-w-[1400px] mx-auto">
          <span className="dctv-eyebrow text-[#e8743b]">Today on air</span>
          <h2 className="font-serif-dctv text-3xl md:text-4xl font-bold text-white mt-4">Broadcast schedule</h2>
          <div className="mt-8 divide-y divide-white/8 border border-white/8 rounded-2xl overflow-hidden">
            {schedule.map((s) => (
              <div key={`${s.time}-${s.title}`} className="flex items-center gap-5 px-6 py-5 bg-[#111726] hover:bg-[#161d2e] transition-colors">
                <span className="font-serif-dctv text-xl text-[#e8743b] font-semibold w-16 flex-shrink-0">{s.time}</span>
                <span className="flex-1 text-white text-[15px] font-medium">{s.title}</span>
                <span className="text-xs font-semibold tracking-wider uppercase text-[#9aa3b2] px-3 py-1 rounded-full border border-white/10">{s.tag}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default WatchLive;
